export enum UserRole {
    ADMIN,	
    STUDENT,
    PARTNER,
    PARTNER_CERT
}